import { z } from 'zod'
import { ticketCategorySchema } from '~/schemas'
import { fetchApi } from './helpers'

export const fetchTicketCategoriesData = async ({
  productId,
  view,
}: {
  productId: string
  /** Storefront view slug (BOAT-1912): only categories carrying the view's label. */
  view?: string | null
}) => {
  const response: any = await fetchApi(
    `/products/${productId}/ticket-categories`,
    view ? { query: { 'search[view]': view } } : undefined,
  )

  const items = z.array(ticketCategorySchema).parse(
    response.items?.map((item: Record<string, any>) => ({
      id: item.data?.id,
      price: item.data?.price,
      wasPrice: item.data?.was_price,
      discountPercent: item.data?.discount_percent,
      minQuantity: item.data?.quantity_min,
      maxQuantity: item.data?.quantity_max,
      title: item.translation?.data?.name,
      colour: item.data?.colour || '#d8d8d8',
      description: item.translation?.data?.description,
      mandatoryHotel: !!item.data?.mandatory_hotel,
      keyFeatureLabels: (item.key_feature_labels || [])
        .map((label: Record<string, any>) => ({
          name: label.extra?.translation?.data?.name,
          colour: label.data?.colour || '#E0F0FF',
        }))
        // A label with no translation in this site's locale renders nothing
        // rather than an empty chip.
        .filter((label: { name?: string }) => !!label.name),
    })),
  )

  const total = z.number().parse(response.total)

  return { items, total }
}

export type TicketCategoriesData = Awaited<
  ReturnType<typeof fetchTicketCategoriesData>
>
